import { render } from "./Payslip.vue?vue&type=template&id=22e1f1e0&scoped=true"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"

import "./Payslip.vue?vue&type=style&index=0&id=22e1f1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e1f1e0"]])

export default __exports__